<template>
  <div class="ai-console" @mousedown="startDrag" :style="{ right: currentRight + 'px', bottom: currentBottom + 'px' }"
    v-if="AIisShow">
    <div class="console-header"> <!-- 添加 mousedown 事件 -->
      <span class="led"></span>
      <span class="title">AI CONSOLE</span>
    </div>
    <div class="console-body">
      <p>> 维权咨询系统已就绪</p>
      <!-- <p>> 点击跳转至AI咨询&nbsp;</p> -->
      <a class="start-btn" @click="goAi">
        <img src="@/assets/images/门户首页切图icon/AI智能咨询.svg">
        立即咨询
      </a>
    </div>
  </div>

</template>
<script>
export default {
  name: 'AI',
  data() {
    return {
      AIisShow: true,
      currentRight: 30,        // 初始右侧距离
      currentBottom: null,     // 初始底部距离（动态计算）
      dragging: false,
      initialMouseX: 0,
      initialMouseY: 0,
      initialRight: 0,
      initialBottom: 0,
    }
  },
  watch: {
    '$route'(newVal) {
      console.log('[ newVal ]-26', newVal)
      if (newVal.path == '/chatAI') {
        this.AIisShow = false
      } else {
        this.AIisShow = true
      }
    }
  },
  mounted() {
    this.currentBottom = window.innerHeight * 0.1

  },
  methods: {
    startDrag(e) {
      e.preventDefault()
      this.dragging = true
      this.initialMouseX = e.clientX
      this.initialMouseY = e.clientY
      this.initialRight = this.currentRight
      this.initialBottom = this.currentBottom

      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag(e) {
      if (!this.dragging) return

      // 计算鼠标移动差值
      const deltaX = e.clientX - this.initialMouseX
      const deltaY = e.clientY - this.initialMouseY

      // 计算新位置并限制边界
      this.currentRight = Math.max(
        0,
        Math.min(
          window.innerWidth - this.$el.offsetWidth,
          this.initialRight - deltaX
        )
      )

      this.currentBottom = Math.max(
        0,
        Math.min(
          window.innerHeight - this.$el.offsetHeight,
          this.initialBottom - deltaY
        )
      )
    },
    stopDrag() {
      this.dragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
    goAi() {
      let userName = '匿名'
      const AIuserInfo = JSON.parse(localStorage.getItem('AIuserInfo'))
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      console.log('[ AIuserInfo ]-34', AIuserInfo)
      if (userInfo && AIuserInfo) {
        console.log('登录', AIuserInfo);
        userName = AIuserInfo.ldGx002a || '匿名'
      } else {
        if (AIuserInfo) {
          localStorage.removeItem('AIuserInfo')
        }
      }
      const href = `/chatAI?userName=${userName}&directives=%E4%BD%A0%E5%A5%BD%E6%88%91%E8%A6%81%E7%BB%B4%E6%9D%83&isSend=false`
      window.open(href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.ai-console {
  position: fixed;
  bottom: 10%;
  right: 30px;
  background: #1A2238;
  border-radius: 8px;
  color: #64FFDA;
  font-family: 'Courier New', monospace;
  width: 240px;
  overflow: hidden;
  z-index: 100;
  cursor: move;

  .console-header {
    background: #2A3355;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;

    .led {
      width: 8px;
      height: 8px;
      background: #FF4757;
      border-radius: 50%;
      animation: led-blink 1s infinite;
    }
  }

  .console-body {
    padding: 16px;
    text-align: center;

    p {
      margin-bottom: 12px;
      font-size: 14px;
    }
  }

  .start-btn {
    background: #64FFDA;
    color: #1A2238;
    padding: 8px 16px;
    border-radius: 4px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: 0.3s;
    font-weight: bold;

    &:hover {
      box-shadow: 0 0 12px rgba(100, 255, 218, 0.4);
    }
  }

  .start-btn:hover {
    transform: translateY(-5px);
  }
}

@keyframes led-blink {
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
</style>